module.exports = __webpack_public_path__ + "img/chat-menu-line.386c786d.svg";